// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"fd60b0d5","900":"242a2028"}[chunkId] + ".chunk.js");